/* eslint-disable no-lonely-if */
/* eslint-disable max-len */
import { debounce } from 'lodash';
import BackgroundVideo from '../../../resources/scripts/helpers/background-video';
import isMobile from '../../../resources/scripts/helpers/is-mobile';

class BrixGrid {
  static init(...parameters) {
    return new BrixGrid(...parameters);
  }

  constructor(block) {
    if (block) {
      let originalBlockOrder = null;
      const backgroundVideoWrapper = document.querySelector(`#${block.id} > .background > .video`);
      const mobileview = block.querySelector('#mobileview');
      const desktopview = block.querySelector('#desktopview');
      const blocks = block.querySelectorAll('.brix-block');
      const container = block.querySelector('.content');
      let mobileorder = null;
      let desktoporder = null;

      if (backgroundVideoWrapper) {
        BackgroundVideo.init(block);
      }

      if (blocks && !originalBlockOrder) {
        originalBlockOrder = blocks;
      }

      const arrayUnique = (array, DOMindex) => {
        if (!DOMindex) {
          return array;
        }
        //  Does index exist?
        const foundDOMindex = array.find((element) => element === DOMindex);
        if (foundDOMindex) {
          // If index exists, are there multple?
          let foundIndex;
          for (let i = 0; i < array.length; i++) {
            if (foundIndex) {
              if (array[i] === DOMindex) {
                array[i] = DOMindex + 1;
              }
            } else {
              if (array[i] === DOMindex) {
                foundIndex = array[i];
              }
            }
          }
          if (array.length === DOMindex) {
            return array;
          }
          return arrayUnique(array, DOMindex + 1);
        }
        // If index doesnt exist find first lowest number in array and assign it to index
        let lowestIndexFound = false;
        let searchIndex = DOMindex;
        while (!lowestIndexFound) {
          searchIndex += 1;
          const lowestNumberIndex = array.findIndex((element) => element === searchIndex);
          if (lowestNumberIndex !== -1) {
            array[lowestNumberIndex] = DOMindex;
            lowestIndexFound = true;
          }
        }
        if (array.length === DOMindex) {
          return array;
        }
        return arrayUnique(array, DOMindex + 1);
      };

      if (mobileview) {
        const parsedMobileorder = JSON.parse(mobileview.value);
        if (parsedMobileorder && parsedMobileorder.length && parsedMobileorder.length === originalBlockOrder.length) {
          // Check to see if any values is undefined, too high or too low.
          for (let i = 0; i < parsedMobileorder.length; i++) {
            if (!parsedMobileorder[i] || parsedMobileorder[i] < 1) {
              parsedMobileorder[i] = 1;
            }
            if (parsedMobileorder[i] > parsedMobileorder.length) {
              parsedMobileorder[i] = parsedMobileorder.length;
            }
          }
          mobileorder = arrayUnique(parsedMobileorder, 1);
        }
      }
      if (desktopview) {
        const parsedDesktoporder = JSON.parse(desktopview.value);
        if (parsedDesktoporder && parsedDesktoporder.length && parsedDesktoporder.length === originalBlockOrder.length) {
          for (let i = 0; i < parsedDesktoporder.length; i++) {
            if (!parsedDesktoporder[i] || parsedDesktoporder[i] < 1) {
              parsedDesktoporder[i] = 1;
            }
            if (parsedDesktoporder[i] > parsedDesktoporder.length) {
              parsedDesktoporder[i] = parsedDesktoporder.length;
            }
          }
          desktoporder = arrayUnique(parsedDesktoporder, 1);
        }
      }

      const rewriteGridOrder = () => {
        if (isMobile() || window.innerWidth <= 575) {
          if (mobileorder && mobileorder.length && mobileorder.length === originalBlockOrder.length) {
            //  remove original order
            [...originalBlockOrder].forEach((brixblock) => {
              brixblock.remove();
            });
            mobileorder.forEach((index) => {
              if (originalBlockOrder[index - 1]) {
                container.append(originalBlockOrder[index - 1]);
              }
            });
          }
        } else {
          if (desktoporder && desktoporder.length && desktoporder.length === originalBlockOrder.length) {
            //  remove original order
            [...originalBlockOrder].forEach((brixblock) => {
              brixblock.remove();
            });
            desktoporder.forEach((index) => {
              if (originalBlockOrder[index - 1]) {
                container.append(originalBlockOrder[index - 1]);
              }
            });
          }
        }
      };

      rewriteGridOrder();

      window.addEventListener('resize', debounce(() => {
        rewriteGridOrder();
      }), 300);
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-grid', BrixGrid.init);
}
